import React from "react";
import BirthdayScreen from "../../Birthday";

const Screen23 = () => {
    return <BirthdayScreen />;
};

export default Screen23;
